import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Assinatura } from '../models/assinatura';

@Injectable({ providedIn: 'root' })
export class AssinaturaService {
  private url = `${environment.apiUrl}/assinaturas`;
  constructor(private http: HttpClient) {}

  getAllByStatus(status: string, tenantId?: string): Observable<Assinatura[]> {
    let headers = this.addTenantHeader(tenantId);
    return this.http.get<Assinatura[]>(`${this.url}/status/${status}`, { headers });
  }

  // Adicionando alias para compatibilidade com os componentes
  getById(id: string): Observable<Assinatura> {
    return this.http.get<Assinatura>(`${this.url}/${id}`);
  }

  getByEmpresa(empresaId: string, tenantId?: string): Observable<Assinatura> {
    let headers = this.addTenantHeader(tenantId);
    return this.http.get<Assinatura>(`${this.url}/${empresaId}`, { headers });
  }

  create(payload: any): Observable<Assinatura> {
    return this.http.post<Assinatura>(`${this.url}`, payload);
  }

  update(id: string, payload: any): Observable<Assinatura> {
    return this.http.put<Assinatura>(`${this.url}/${id}`, payload);
  }

  validarAssinatura(empresaId: string, tenantId?: string): Observable<boolean> {
    let headers = this.addTenantHeader(tenantId);
    return this.http.get<boolean>(`${this.url}/${empresaId}/validar`, { headers });
  }

  renovar(id: string, payload: any): Observable<Assinatura> {
    return this.renovarAssinatura(id, payload);
  }

  renovarAssinatura(empresaId: string, payload: any, tenantId?: string): Observable<Assinatura> {
    let headers = this.addTenantHeader(tenantId);
    return this.http.post<Assinatura>(`${this.url}/${empresaId}/renovar`, payload, { headers });
  }

  suspenderAssinatura(empresaId: string, tenantId?: string): Observable<Assinatura> {
    let headers = this.addTenantHeader(tenantId);
    return this.http.patch<Assinatura>(`${this.url}/${empresaId}/suspender`, null, { headers });
  }

  cancelar(id: string): Observable<Assinatura> {
    return this.cancelarAssinatura(id);
  }

  cancelarAssinatura(empresaId: string, tenantId?: string): Observable<Assinatura> {
    let headers = this.addTenantHeader(tenantId);
    return this.http.patch<Assinatura>(`${this.url}/${empresaId}/cancelar`, null, { headers });
  }

  reativarAssinatura(empresaId: string, plano: string, tenantId?: string): Observable<Assinatura> {
    let headers = this.addTenantHeader(tenantId);
    return this.http.post<Assinatura>(`${this.url}/${empresaId}/reativar?plano=${plano}`, null, { headers });
  }

  bloquearEmpresa(empresaId: string, tenantId?: string): Observable<void> {
    let headers = this.addTenantHeader(tenantId);
    return this.http.patch<void>(`${this.url}/${empresaId}/bloquear`, null, { headers });
  }

  desbloquearEmpresa(empresaId: string, tenantId?: string): Observable<void> {
    let headers = this.addTenantHeader(tenantId);
    return this.http.patch<void>(`${this.url}/${empresaId}/desbloquear`, null, { headers });
  }

  verificarAssinaturasVencidas(): Observable<void> {
    return this.http.post<void>(`${this.url}/verificar-vencidas`, null);
  }

  // Helper para adicionar header do Tenant
  private addTenantHeader(tenantId?: string): HttpHeaders | undefined {
    if (tenantId) {
      return new HttpHeaders({'X-Tenant-ID': tenantId});
    }
    return undefined;
  }
}
